import { render, staticRenderFns } from "./FormTextAreaFloatingLabel.vue?vue&type=template&id=59f1e142&"
import script from "./FormTextAreaFloatingLabel.vue?vue&type=script&lang=js&"
export * from "./FormTextAreaFloatingLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports